export enum TemplateList {
  POGGERS = 'poggers',
  MATERIDOUSKA = 'materidouska',
}